import { defineStore } from 'pinia'
import { SnackBar } from '@/types'
import { shallowReactive } from 'vue'
export const snackBarStore = defineStore('snackbar', {
  state: () => {
    return {
      snackBarArray: shallowReactive([]) as SnackBar[],
    }
  },
  actions: {
    showWarningSnackBar(title: string) {
      this.snackBarArray.push({
        show: true,
        title,
        icon: {
          color: 'text-jsYellow-60',
          icon: ['fas', 'circle-exclamation'],
        },
      })
    },
    showErrorSnackBar(title: string) {
      this.snackBarArray.push({
        show: true,
        title,
        icon: { color: 'text-jsRed-60', icon: ['fas', 'circle-xmark'] },
      })
    },
    showSuccessSnackBar(
      title: string,
      options?: {
        position?: SnackBar['position']
        link?: { text: string; to: any }
      }
    ) {
      this.snackBarArray.push({
        show: true,
        title,
        icon: { color: 'text-jsGreen-60', icon: ['fas', 'circle-check'] },
        ...options
      })
    },
    showSnackBar(snackBarConfigurations: any) {
      snackBarConfigurations.show = true
      this.snackBarArray.push(snackBarConfigurations)
    },
    hideSnackBar() {
      this.snackBarArray.splice(0, 1)
    },
  },
  getters: {
    getSnackBar(): SnackBar {
      return this.snackBarArray[0]
    },
  },
})
